import React from 'react'

export const Locality = ({ localityDetails, heading }) => {
  const hasContent = localityDetails?.name?.length > 0;

  return (
    <div className="min-h-30"> {/* Reserve enough vertical space */}
      {hasContent && (
        <div className='space-y-4'>
          {/* Was a bare bold div, so the only genuinely locality-specific block on the
              page carried no heading and never mentioned the service. */}
          <h2 className="font-bold text-lg">
            {heading ? heading : `About ${localityDetails.name}`}
          </h2>
          <p className="wrap-break-word whitespace-pre-wrap text-sm leading-7 space-y-2">
            {localityDetails.description}
          </p>
        </div>
      )}
    </div>
  );
};

